export default {
  logo: 'https://media.bijixia.net/image/default/87DE0CF7A0D24BEB93D4F50D134E198F-6-2.png',

}